module.exports = __webpack_public_path__ + "static/assets/0bf3f973e1b9013faaa6cfe3298e1078.gif";